import {Component, Inject, Optional} from '@angular/core';
import {APP_DIALOG_DATA, DialogService} from '../../../core/services/dialog.service';
import {MoshicomApiService} from '../../../core/services/moshicom-api.service';
import {TeamMoshicomUserConnection} from '../../../core/model/resources/team';
import {FormControl, Validators} from '@angular/forms';
import {LoadingService} from '../../../core/services/loading.service';

@Component({
    selector: 'app-moshicom-account',
    templateUrl: './moshicom-account.component.html',
    styleUrl: './moshicom-account.component.scss',
    standalone: false
})
export class MoshicomAccountComponent {

  teamId: number;
  connections: TeamMoshicomUserConnection[];
  idFormCtl: FormControl<string> = new FormControl<string>('', {
    validators: [Validators.required, Validators.minLength(1)],
    nonNullable: true,
  });
  passwordFormCtl: FormControl<string> = new FormControl<string>('', {
    validators: [Validators.required, Validators.minLength(1)],
    nonNullable: true,
  });
  isUpdated = false;

  constructor(@Inject(APP_DIALOG_DATA) @Optional() readonly data: {
                teamId: number,
                connections: TeamMoshicomUserConnection[]
              },
              private dialogService: DialogService,
              private loadingService: LoadingService,
              private moshicomApiService: MoshicomApiService) {
    this.teamId = data.teamId;
    this.connections = data.connections;
  }

  async delete(target: TeamMoshicomUserConnection) {
    const isOK = await this.dialogService.confirm({content: '連携を解除します。\n本当によろしいですか？'});
    if (!isOK) {
      return;
    }
    const res = await this.moshicomApiService.deleteConnection(this.teamId, target.moshicom_user_id);
    if (!res) {
      await this.dialogService.alert({content: '予期せぬエラーが発生しました。通信環境の良い場所でもう一度お試しください。'});
      return;
    }
    this.connections = this.connections.filter(connection => connection.moshicom_user_id !== target.moshicom_user_id);

    await this.dialogService.information({content: '連携を解除しました。'});
    this.isUpdated = true;
  }

  async login() {
    const connection = await this.moshicomApiService.postConnection(this.teamId, this.idFormCtl.value, this.passwordFormCtl.value);
    if (!connection) {
      await this.dialogService.alert({content: 'ID/メールアドレスまたはパスワードが異なります。'})
      return;
    }
    if (this.connections.find(exist => connection.moshicom_user_id === exist.moshicom_user_id)) {
      await this.dialogService.alert({content: '既に連携済みのアカウントです。'})
      // 属性が変更されているときは一応更新できるように入れ替えておく。
      this.connections = this.connections.filter(exist => connection.moshicom_user_id !== exist.moshicom_user_id);
      this.connections.push(connection);
    } else {
      this.connections.push(connection);
      this.isUpdated = true;
    }
  }

  close() {
    this.dialogService.hide(this.isUpdated, true);
  }
}
